import { useCallback, useEffect, useState } from "react";
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import { RequestCache } from "shared/@hooks/useRequestCache";

export function useBSM({ iboNumber, page = 0, limit = 25 }) {
  const { makeAuthedRequest } = Auth.useContainer();
  const cache = RequestCache.useContainer();

  const { logError } = useLogger({ prefix: "useBSM" });
  const [requestId, setRequestId] = useState(0);
  const [records, setRecords] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);

  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/transactions/${iboNumber}/bsm?page=${page}&limit=${limit}&req=${requestId}`,
    null,
    cache
  );

  // Prevent records from becoming null between refreshes.
  useEffect(() => {
    if (data != null) {
      setRecords(data);
    }
  }, [data]);

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  const cancelOrder = useCallback(
    async (orderId) => {
      setIsWaiting(true);
      return makeAuthedRequest(
        `/v1/membership/transactions/${iboNumber}/bsm/${orderId}`,
        { method: "DELETE" }
      )
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .catch(logError)
        .finally(() => {
          setIsWaiting(false);
          refresh();
        });
    },
    [iboNumber]
  );

  return {
    records,
    loading,
    isWaiting,
    refresh,
    cancelOrder,
  };
}
